export const getSequencedState = (params: {
  targetChatId: string;
  seqValue: number;
  sequencedMessagesRef: React.MutableRefObject<Map<string, { nextSeq: number; buffer: Map<number, string>; lastSeq: number }>>;
  lastReceivedSeqRef: React.MutableRefObject<Map<string, number>>;
  missingSeqRef: React.MutableRefObject<Map<string, number>>;
  missingSeqRetriesRef: React.MutableRefObject<Map<string, number>>;
  missingSeqTimersRef: React.MutableRefObject<Map<string, number>>;
}) => {
  const {
    targetChatId,
    seqValue,
    sequencedMessagesRef,
    lastReceivedSeqRef,
    missingSeqRef,
    missingSeqRetriesRef,
    missingSeqTimersRef,
  } = params;

  const state = sequencedMessagesRef.current.get(targetChatId)
    ?? { nextSeq: 1, buffer: new Map(), lastSeq: 0 };
  if (!sequencedMessagesRef.current.has(targetChatId)) {
    sequencedMessagesRef.current.set(targetChatId, state);
  }

  let resetSequence = false;
  if (seqValue === 0 && state.nextSeq === 1 && state.lastSeq === 0 && state.buffer.size === 0) {
    state.nextSeq = 0;
    resetSequence = true;
  }

  if (seqValue === 1 && state.nextSeq > 1) {
    state.nextSeq = 1;
    state.buffer.clear();
    state.lastSeq = 0;
    resetSequence = true;
  }

  if (resetSequence) {
    lastReceivedSeqRef.current.set(targetChatId, 0);
    missingSeqRef.current.delete(targetChatId);
    missingSeqRetriesRef.current.delete(targetChatId);
    const timerId = missingSeqTimersRef.current.get(targetChatId);
    if (timerId) {
      clearTimeout(timerId);
      missingSeqTimersRef.current.delete(targetChatId);
    }
  }

  const previousReceived = resetSequence ? 0 : (lastReceivedSeqRef.current.get(targetChatId) ?? 0);
  lastReceivedSeqRef.current.set(targetChatId, seqValue);

  return { state, previousReceived };
};
